module.exports = __webpack_public_path__ + "media/images/top/mainvisual-2f7c0912907ccce9ce3c258de64d71a5.png";